module.exports = __webpack_public_path__ + "fonts/Quicksand-Bold.76f20c5.ttf";